import columns from '../../../../react-table/helpers/columns';

export const statusConditionalProps = (state, rowInfo) => {
  let className = '';
  if (rowInfo) {
    if (rowInfo.row.status === 'Denested') {
      className = 'link text-green';
    }
    if (rowInfo.row.status === 'Not denested') {
      className = 'link text-red';
    }
    if (rowInfo.row.status === 'Excluded Denested') {
      className = 'link text-green-strike-through';
    }
    if (rowInfo.row.status === 'Excluded Not Denested') {
      className = 'link text-red-strike-through';
    }
    if (rowInfo.row.status === 'Duplicate') {
      className = 'link text-strike-through';
    }
    if (rowInfo.row.status === 'NEST START' || rowInfo.row.status === 'nest start' || rowInfo.row.status === 'Nest Start' || rowInfo.row.status === 'Nest start' || rowInfo.row.status === 'Start') {
      className = 'link bg-through-green';
    }
    if (rowInfo.row.status === 'NEST STOP' || rowInfo.row.status === 'nest stop' || rowInfo.row.status === 'Nest Stop' || rowInfo.row.status === 'Nest stop' || rowInfo.row.status === 'Stop') {
      className = 'link bg-through-light-grey';
    }
    if (rowInfo.row.status === 'Unused MRD label') {
      className = 'link text-bold-blue';
    }
  }
  return {
    className,
  };
};

export default (data) => {
  const {
    TextColumn,
    ExternalReceptacleLinkColumn,
    DateTimeColumnwithSecond,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('Workstation', 'workstation'),
        new ExternalReceptacleLinkColumn(new TextColumn('Receptacle ID', 'receptacleId').withWidth(300).withGetProps(statusConditionalProps)),
        new DateTimeColumnwithSecond('Postal scan time', 'postalScanTime'),
        new TextColumn('MRD label', 'mrdLabel').withWidth(300),
        new DateTimeColumnwithSecond('Handover time', 'handoverTime'),
        new TextColumn('Handler', 'handler'),
        new TextColumn('Carrier', 'carrier'),
        new TextColumn('Flight', 'flight'),
        new TextColumn('Status', 'status'),
      ],
    },
  ];
};
